import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface RejectOfferResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function rejectOfferAction(requisitionId: string): Promise<ApiResponse<RejectOfferResponse>> {
  return api.put<ApiResponse<RejectOfferResponse>>(`/offers/${requisitionId}/reject`)
}
